// imports section Start
import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Giftcertificatedata } from "../../assets/Griddata"; // Import dataset
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { useState, useEffect } from "react";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_14 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { currencyFormatLKR } from "../../../src/utils/common/CurrencyFormat";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";
import AddBoxIcon from "@mui/icons-material/AddBox";

// imports section End

function ViewGiftCertificate() {
  // Hooks start
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, BUSINESSTYPECODE } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const gotToPage = () => {
    navigate("/Giftcertificate");
  };

  const gotoMenuPage1 = () => {
    navigate("/vGiftVoucher");
  };

  const gotoMenuPage2 = () => {
    navigate("/pathToGotoPage");
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      CERTIFICATECODE: item.CERTIFICATECODE,
      REFERENCECODE: item.REFERENCECODE,
      GIFTNAME: item.GIFTNAME,
      EXPIRYDATE: item.EXPIRYDATE,
      AMOUNT: currencyFormatLKR(item.AMOUNT, "LKR", false),
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.GIFTNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.AMOUNT.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.CERTIFICATECODE === id);
      if (selectedItem) {
        navigate(`/Giftcertificate`, { state: { selectedItem, actionText } });
      }
    } else if (actionText === "Add Gift Voucher") {
      const selectedItem = data.find((item) => item.CERTIFICATECODE === id);
      if (selectedItem) {
        // Pass both the selectedItem and the CERTIFICATECODE to the vGiftVoucher page
        navigate(`/vGiftVoucher`, {
          state: {
            selectedItem,
            CERTIFICATECODE: selectedItem.CERTIFICATECODE,
          },
        });
      }
      setSelectedItem(selectedItem);
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (CERTIFICATECODE) => handleItemClick(CERTIFICATECODE, "Edit"),
    },

    {
      text: "Add Voucher",
      icon: <AddBoxIcon />,
      onClick: (CERTIFICATECODE) =>
        handleItemClick(CERTIFICATECODE, "Add Gift Voucher"),
    },
  ];
  const rows = filteredData ? mapResultToRows(filteredData) : [];
  // Handlers end

  // API calls start

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_14, "get", {
        COMPCODE,

        BUSINESSTYPECODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };
  // API calls end

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Customer</Link>
                <Link underline="none">Gift Certificate</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                {/* <FormControl variant="outlined">
                <TextField
                    sx={{ ...styles.VI_SearchField }}
                    size="small"
                    label="Search Items"
                    value={searchText}
                    onChange={handleSearchChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              background: theme.palette.primary.main,
                              mr: -1.7,
                              height: 38,
                              color: theme.palette.text.buttontxt,
                              textTransform: "capitalize",
                              letterSpacing: "1px",
                            }}
                          >
                            <SearchIcon sx={{ marginLeft: 1 }} />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl> */}
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => gotToPage()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Giftcertificatedata.columns}
          rows={rows.map((item) => ({ ...item, id: item.CERTIFICATECODE }))}
          menuItems={menuItems}
          tabletitle={Giftcertificatedata.name}
          gridid="CERTIFICATECODE"
        />
      )}
    </div>
  );
}

export default ViewGiftCertificate;
